import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { PrismicRichText, PrismicLink } from '@prismicio/react'

const PrivateTreaty = ({ isLoggedIn, slice }) => {
  const data = useStaticQuery(graphql`
    {
      allBidJs(sort: { featured: DESC }) {
        edges {
          node {
            ...BidJSFragment
          }
        }
      }
      prismicConfig {
        ...PrismicConfigFragment
      }
    }
  `)
  const configData = data.prismicConfig.data
  var privateTreaties = []
  slice.items.forEach((bidJs, index) => {
    const privateTreaty = data.allBidJs.edges.find((story) => bidJs.private_treaty_auction_id === story.node.auctionId) || null
    if (privateTreaty) {
      privateTreaties.push(privateTreaty)
      return
    }
  })
  return (
    <section className='component-private_treaty mx-auto max-w-screen-xl p-6'>
      {slice.primary.private_treaty_title.richText && (
        <div className='prose min-w-full'>
          <PrismicRichText field={slice.primary.private_treaty_title.richText} />
        </div>
      )}
      <div className='mb-10 border-b border-gray-200'>
        <nav className='-mb-px flex justify-around md:justify-start' aria-label='Tabs'>
          <PrismicLink className='w-auto border-b-2 border-transparent py-4 text-center font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700 md:px-8' href='../#!/'>
            {configData.auction || 'Auction'}
          </PrismicLink>
          <PrismicLink className='w-auto border-b-2 border-transparent py-4 text-center font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700 md:px-8' href='../#!/marketplace'>
            {configData.marketplace || 'Marketplace'}
          </PrismicLink>
          <PrismicLink className='w-auto border-b-2 border-blue-800 py-4 text-center font-medium text-blue-900 md:px-8' href='../private-treaty'>
            {configData.private_treaty || 'Private Treaty'}
          </PrismicLink>
        </nav>
      </div>
      <ul className='space-y-4'>
        {privateTreaties.map((privateTreaty, index) => {
          let privateTreatyData = privateTreaty.node
          let started = false
          let numberOfImages = 5
          if (privateTreatyData.auctionLogo && privateTreatyData.auctionLogo !== 'null') {
            numberOfImages = 4
          }
          if (Date.now() > privateTreatyData.auctionStartTime) {
            started = true
          }
          let buttonText = 'Log in to bid'
          if (isLoggedIn) {
            buttonText = 'Register for this sale'
          }
          if (privateTreatyData.catalogue) {
            buttonText = 'Catalogue Auction'
          }
          return (
            <li className='relative rounded border bg-white p-4' key={`privateTreaty-${index}`}>
              <span className='absolute top-0 right-0 inline-flex items-center rounded-bl bg-info py-0.5 px-2 text-sm font-semibold text-white'>
                <svg xmlns='http://www.w3.org/2000/svg' className='mr-1 h-4 w-4' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
                  <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z' />
                </svg>
                {privateTreatyData.typeMessage}
              </span>
              <div className='grid h-52 grid-cols-2 gap-3 lg:grid-cols-5'>
                {privateTreatyData.auctionLogo && privateTreatyData.auctionLogo !== 'null' && (
                  <img className='tw-hidden h-52 w-full object-cover lg:block' alt='' src={privateTreatyData.auctionLogo} />
                )}
                {privateTreatyData.upcomingItems?.slice(0, numberOfImages).map((upcomingItems, index) => {
                  return <img className={`h-52 w-full object-cover ${index > 1 ? 'tw-hidden lg:block' : ''}`} src={upcomingItems.attachmentModel.attachmentUrl} alt='' key={`upcomingItems-${index}`} />
                })}
              </div>
              <div className='grid grid-cols-1 gap-6 p-4 md:grid-cols-4'>
                <div className='col-span-3 space-y-2'>
                  <div className='font-semibold'>{started && <div>Started</div>}</div>
                  <div className='text-lg font-semibold'>{privateTreatyData.endsOrStarts}</div>
                  <PrismicLink href={`../#!/auctionDetails/${privateTreatyData.auctionId}`} className='text-xl uppercase text-blue-900'>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: `${privateTreatyData.title}`
                      }}
                    />
                    <span className='inline-block w-20 pl-2 text-xs text-gray-500'>
                      ({privateTreatyData.itemCount} item{privateTreatyData.itemCount > 1 && 's'})
                    </span>
                  </PrismicLink>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `${privateTreatyData.description}`
                    }}
                  />
                </div>
                <div className='flex-col md:flex'>
                  <div className='mb-4 text-right font-semibold'>{privateTreatyData.location}</div>
                  <PrismicLink href={`../#!/auctionDetails/${privateTreatyData.auctionId}`} className='button button-brand mt-auto block w-full text-center md:w-auto'>
                    {buttonText}
                  </PrismicLink>
                </div>
              </div>
            </li>
          )
        })}
      </ul>
    </section>
  )
}

export default PrivateTreaty
